import { async_lazy } from "../../../Lazy";
import { NeedleImage } from "../../capture";
import { CapturedChatbox } from "./CapturedChatbox";
export var ChatAnchors;
(function (ChatAnchors) {
    var getFont = CapturedChatbox.getFont;
    let Needles;
    (function (Needles) {
        Needles.instance = async_lazy(async () => {
            return {
                brackets: [
                    {
                        font: getFont(10),
                        baseline_y_from_needle_top: 8,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_10pt.png")
                    },
                    {
                        font: getFont(12),
                        baseline_y_from_needle_top: 10,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_12pt.png")
                    },
                    {
                        font: getFont(14),
                        baseline_y_from_needle_top: 12,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_14pt.png")
                    },
                    {
                        font: getFont(16),
                        baseline_y_from_needle_top: 12,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_16pt.png")
                    },
                    {
                        font: getFont(18),
                        baseline_y_from_needle_top: 14,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_18pt.png")
                    },
                    {
                        font: getFont(20),
                        baseline_y_from_needle_top: 16,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_20pt.png")
                    },
                    {
                        font: getFont(22),
                        baseline_y_from_needle_top: 17,
                        img: await NeedleImage.fromURL("/alt1anchors/chat/lbracket_22pt.png")
                    },
                ],
                top_rights: await NeedleImage.AlternativeSet.fromURLs("/alt1anchors/chat/tr_minus.png", "/alt1anchors/chat/tr_plus.png", "/alt1anchors/chat/tr_minus_hover.png", "/alt1anchors/chat/tr_plus_hover.png"),
                chatbubble: await NeedleImage.fromURL("/alt1anchors/chat/chatbubble.png"),
                bot_left: await NeedleImage.fromURL("/alt1anchors/chat/chat_bar_bl.png"),
            };
        });
    })(Needles = ChatAnchors.Needles || (ChatAnchors.Needles = {}));
})(ChatAnchors || (ChatAnchors = {}));
